package music.jammers.client.shared.event.presentation.ui

import androidx.compose.runtime.Composable
import limasoul.client.shared.generated.resources.Res
import limasoul.client.shared.generated.resources.validation_error_date_before_now
import limasoul.client.shared.generated.resources.validation_error_empty_value
import limasoul.client.shared.generated.resources.validation_error_invalid_date
import limasoul.client.shared.generated.resources.validation_error_invalid_digit
import limasoul.client.shared.generated.resources.validation_error_invalid_symbol
import limasoul.client.shared.generated.resources.validation_error_item_not_selected
import limasoul.client.shared.generated.resources.validation_error_items_max_selected
import limasoul.client.shared.generated.resources.validation_error_max_int_value
import limasoul.client.shared.generated.resources.validation_error_max_length
import limasoul.client.shared.generated.resources.validation_error_min_int_value
import limasoul.client.shared.generated.resources.validation_error_must_start_with
import music.jammers.client.shared.event.domain.model.ValidationErrorValue
import org.jetbrains.compose.resources.stringResource

@Composable
fun ValidationErrorValue?.getString(): String? = when (this) {
    ValidationErrorValue.DateBeforeNow      -> {
        stringResource(Res.string.validation_error_date_before_now)
    }

    ValidationErrorValue.EmptyValue         -> {
        stringResource(Res.string.validation_error_empty_value)
    }

    ValidationErrorValue.InvalidDate        -> {
        stringResource(Res.string.validation_error_invalid_date)
    }

    ValidationErrorValue.InvalidDigit       -> {
        stringResource(Res.string.validation_error_invalid_digit)
    }

    ValidationErrorValue.InvalidSymbol      -> {
        stringResource(Res.string.validation_error_invalid_symbol)
    }

    ValidationErrorValue.ItemNotSelected    -> {
        stringResource(Res.string.validation_error_item_not_selected)
    }

    is ValidationErrorValue.ItemsMaxCount    -> {
        stringResource(Res.string.validation_error_items_max_selected, limit, actual)
    }

    is ValidationErrorValue.MaxInt          -> {
        stringResource(Res.string.validation_error_max_int_value, value)
    }

    is ValidationErrorValue.MinInt          -> {
        stringResource(Res.string.validation_error_min_int_value, value)
    }

    is ValidationErrorValue.StringMaxLength -> {
        stringResource(Res.string.validation_error_max_length, limit, actual)
    }

    is ValidationErrorValue.MustStartWith   -> {
        stringResource(Res.string.validation_error_must_start_with, prefix)
    }

    null                                    -> null
}